module.exports = __webpack_public_path__ + "img/love.43a05a8c.svg";